var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Frame_1020",
    "data-name": "Frame 1020",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.002,
    height: 40.002,
    viewBox: "0 0 40.002 40.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_1020_Background_Mask_",
    "data-name": "Frame 1020 (Background/Mask)",
    width: 40.002,
    height: 40.002,
    rx: 20.001,
    fill: "#45b26b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "eth_1_Background_Mask_",
    "data-name": "eth 1 (Background/Mask)",
    width: 40,
    height: 40,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Frame_1020_Background_Mask_2",
    "data-name": "Frame 1020 (Background/Mask)",
    width: 40.002,
    height: 40.002,
    rx: 20.001,
    fill: "#45b26b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame_1020-2",
    "data-name": "Frame 1020",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eth_1",
    "data-name": "eth 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "eth_1_Background_Mask_2",
    "data-name": "eth 1 (Background/Mask)",
    width: 40,
    height: 40,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eth_1-2",
    "data-name": "eth 1",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20,40A20,20,0,1,1,40,20,20,20,0,0,1,20,40Z",
    fill: "#627eea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    "data-name": "Group",
    transform: "translate(12 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,9.609l8.121,3.629L0,0Z",
    transform: "translate(8.123)",
    fill: "rgba(255,255,255,0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,13.238,8.123,9.609V0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,11.244,8.127,0,0,4.715Z",
    transform: "translate(8.123 14.75)",
    fill: "rgba(255,255,255,0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M8.123,4.713,0,0,8.123,11.244Z",
    transform: "translate(0 14.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M8.121,3.627,0,0V8.343Z",
    transform: "translate(8.123 9.611)",
    fill: "rgba(255,255,255,0.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M8.123,8.343V0L0,3.627Z",
    transform: "translate(0 9.611)",
    fill: "rgba(255,255,255,0.6)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.e2a6ee2ff0211b4b458df8875b70aefa.svg";
export { ForwardRef as ReactComponent };